import React from 'react'
import { CurrentUserContext } from '../../../libraries/auth'
import Avatar from '../../components/layout/Avatar'
import PremiumTag from '../../components/premium/Tag'

type Props = { size?: 'md' | 'lg' | 'xl', hideSubscriptionTag?: boolean }
const UserAvatar: React.FC<Props> = ({ size, hideSubscriptionTag }) => {
  const { currentUser, isSubscriptionActive } = React.useContext(CurrentUserContext)
  if(!currentUser) return null
  return (
    <div className='items-center flex flex-col gap-y-1'>
      <Avatar label={currentUser?.name} size={size} />
      {isSubscriptionActive && !hideSubscriptionTag && <PremiumTag size='sm' hideIcon />}
    </div>)
}

export default React.memo(UserAvatar)
